import React, { useEffect } from 'react';
import { useParams, useHistory, generatePath } from 'react-router-dom';
import { createState, useState, Downgraded } from '@hookstate/core';
// import CKEditor from 'ckeditor4-react';
import moment from 'moment';
import {
    Box,
    Grid,
    TextField,
    MenuItem,
    FormControl,
    Select,
    InputLabel,
    Divider,
    CircularProgress,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
// import stores
import { exitTheme, useThemeState } from '../../hookState/ThemeState';
// import utility and constants
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
// import shared components
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import Title from '../../sharedcomponents/title/title';

import { eventView } from '../../constants/Constant';
import TinyMCEEditor from '../../sharedcomponents/tinymceEditor/tinymce';
import MUIDatePicker from '../../sharedcomponents/datePicker';
import dayjs from 'dayjs';
import { useEventState } from '../../stores/eventStore';

const useStyles = makeStyles(() => ({
    itemRoot: {
        textAlign: 'left',
    },
    txtArea: {
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        padding: '16.5px 14px',
        fontSize: '1rem',
        borderColor: '#cbcbcb',
        borderRadius: '6px',
    },
    buttonContent: {
        margin: '8px',
    },
    pic: {
        width: '310px',
        height: '180px',
        marginLeft: 1,
    },
    buttonColor: {
        width: '62px',
        height: '62px',
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        marginTop: '5%'
    },
}));

const eventState = createState({
    eventName: '',
    eventLocation: '',
    eventNotes: '',
    eventStatus: 1,
    eventColor: '',
    picUrl: '',
    picture: '',
    src: '',
    eventView: 2,
    eventHighLevelInfo: ''
});

const selectStatus = [
    {
        id: 1,
        value: 'Active',
    },
    {
        id: 2,
        value: 'Completed',
    },
    {
        id: 3,
        value: 'Cancelled',
    },
];

const EditEventDetail = () => {
    const classes = useStyles();
    let params = useParams();
    const eventStates = useEventState();
    const history = useHistory();
    const state = useState(eventState);
    const loading = useState(false);
    const disableButton = useState(false);
    const themeState = useThemeState();
    const [primaryColor, setPrimaryColor] = React.useState(
        themeState.primary.value
    );
    const [secondaryColor, setSecondaryColor] = React.useState(
        themeState.secondary.value
    );
    const [eventStartDate, setEventStartDate] = React.useState(new Date);
    const [eventEndDate, setEventEndDate] = React.useState(new Date);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [eventNameErr, setEventNameErr] = React.useState('');
    const [eventLocErr, setEventLocErr] = React.useState('');
    const [startDateError, setStartDateError] = React.useState('');
    const [endDateError, setEndDateError] = React.useState('');

    const [eventID, setEventID] = React.useState(0);
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [loader, setLoader] = React.useState(true);
    const [eventData, setEventData] = React.useState([]);
    const userInfo = Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const resetState = () => {
        state.set({
            eventName: '',
            eventLocation: '',
            eventNotes: '',
            eventHighLevelInfo: '',
            eventStatus: 1,
            eventColor: '',
            picUrl: '',
            picture: '',
            src: '',
            eventView: 2,
        });
        setEventID(0);
        //setProfilePic('');
        setPrimaryColor(themeState.primary.value);
        setSecondaryColor(themeState.secondary.value);
        setEventStartDate(new Date());
        setEventEndDate(new Date());
        setSnackBarProps({
            openSnack: false,
            variant: 'error',
            message: '',
        });
    };

    useEffect(() => {
        getEventDetails()
    }, []);

    const getEventDetails = () => {
        ApiHelper.get(APIURLConstants.GET_EVENT(eventInfo.eventID, 0))
            .then((res) => {
                if (res.data) {
                    setLoader(false)
                    setEventData(res.data)
                    eventStates.eventDetail.set(res.data);
                    Helper.setStorage('eventInfo', res.data);
                    const editEventState = res.data;
                    const data = {
                        eventName: editEventState.eventName,
                        eventLocation: editEventState.venue,
                        eventNotes: editEventState.notes,
                        eventHighLevelInfo: editEventState.highLevelEventInfo === null || editEventState.highLevelEventInfo === undefined ? "" : editEventState.highLevelEventInfo,
                        eventStatus: editEventState.status,
                        picUrl: editEventState.imageUrl,
                        picture: editEventState.imageUrl,
                        src: '',
                        eventView: editEventState.readonlyOrHide,
                    };
                    state.set(data);

                    setEventID(Number(params.eventID));
                    setEventStartDate(editEventState.startDate);
                    setEventEndDate(editEventState.endDate);
                    const color = JSON.parse(editEventState.color);
                    setPrimaryColor(color.primary);
                    setSecondaryColor(color.secondary);
                }
            }).catch((err) => {
                resetState()
                setLoader(false)
                console.log(err);
            })
    }

    const saveAppNotificationData = () => {
        const userInfo = Helper.getStorage('userInfo');
        let appNotificationUserIds = [];

        setTimeout(() => {
            const AppNotificationData = {
                userIDs: appNotificationUserIds.toString(),
                appNotificationTypeID: 4,
                eventID: Number(eventID),
                moduleID: 9,
                recordRefID: Number(eventID),
                requestStatus: 2,
                status: 0,
                createdBy: userInfo.userID
            }

            ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, AppNotificationData)
                .then(res => {
                    // console.log("res1", res);

                })
                .catch(err => {
                    console.log("err", err);
                });
        }, 1000);
    }

    const handleClick = async (event) => {
        event.preventDefault();
        Helper.removeStorage('eventInfo')
        const userInfo = Helper.getStorage('userInfo');
        const selectedState = state.get();
        if (
            selectedState.eventName.trim().length == 0 ||
            selectedState.eventLocation.trim().length == 0
        ) {
            return false;
        }
        // Use dayjs to format the dates
        const formattedStartDate = dayjs(eventStartDate).format('[YYYYescape] YYYY-MM-DDT00:00:00');
        const formattedEndDate = dayjs(eventEndDate).format('[YYYYescape] YYYY-MM-DDT00:00:00');

        const fetStartDate = Helper.LocalEasternTime(formattedStartDate);
        const fetEndDate = Helper.LocalEasternTime(formattedEndDate);


        if (moment(fetEndDate).diff(moment(fetStartDate), 'days') <= -1) {
            setStartDateError('Start date should be less or equal to end date');
            return false;
        } else if (
            moment(fetStartDate).diff(
                moment(Helper.LocalEasternTime(moment())),
                'days'
            ) >= 0
        ) {
            setStartDateError('');
        } else if (
            moment(fetEndDate).diff(
                moment(Helper.LocalEasternTime(moment())),
                'days'
            ) >= 0
        ) {
            setEndDateError('');
        }

        if (eventID > 0) {
            // check start date is less than end date
            if (moment(fetEndDate).diff(moment(fetStartDate), 'days') <= -1) {
                return false;
            }
        } else {
            var today = moment().format('YYYY-MM-DD');
            today = Helper.LocalEasternTime(`${today}T00:00`);
            // check start date  and end date is less than todays date
            if (
                moment(fetStartDate).diff(moment(today)) < 0 ||
                moment(fetEndDate).diff(moment(today)) < 0
            ) {
                return false;
            }
        }

        if (eventNameErr.length > 0 || eventLocErr.length > 0) {
            return false;
        }

        const imageReq = { ...state.attach(Downgraded).get() };

        imageReq.picUrl = state.picUrl.get() ? state.picUrl.get() : '';

        delete imageReq.picture;
        delete imageReq.src;

        let eventInfo = {
            EventID: Number(eventID),
            EventName: selectedState.eventName,
            Notes: selectedState.eventNotes != '' ? encodeURIComponent(selectedState.eventNotes) : selectedState.eventNotes,
            highLevelEventInfo: selectedState.eventHighLevelInfo != '' ? encodeURIComponent(selectedState.eventHighLevelInfo) : selectedState.eventHighLevelInfo,
            StartDate: Helper.ConvertToEasternTime(fetStartDate),
            EndDate: Helper.ConvertToEasternTime(fetEndDate),
            Color: JSON.stringify({
                primary: primaryColor,
                secondary: secondaryColor,
            }),
            ImageUrl: imageReq.picUrl,
            Venue: selectedState.eventLocation,
            Status: selectedState.eventStatus,
            CreatedBy: userInfo ? userInfo.userID : 1,
            ReadonlyOrHide: selectedState.eventView,
        };
        eventInfo = Helper.trimObject(eventInfo);

        let snackBarProp = { ...snackBarProps };
        loading.set(true);
        disableButton.set(true);
        ApiHelper.post(APIURLConstants.POST_EVENT_INFO, eventInfo)
            .then((res) => {
                if (res.data > 0) {
                    let eventDetails = eventStates.eventDetail.attach(Downgraded).get();
                    eventDetails.notes = null
                    eventStates.eventDetail.set(eventDetails)
                    getEventDetails()
                    snackBarProp.variant = 'success';
                    snackBarProp.message =
                        eventID > 0
                            ? 'Event updated successfully'
                            : 'Event added successfully';
                    snackBarProp.openSnack = true;
                    setSnackBarProps(snackBarProp);
                    if (selectedState.eventView === 0 && eventID > 0 && eventInfo.Status === 1) {
                        saveAppNotificationData();
                    }
                    setTimeout(() => {
                        resetState();
                        const path = generatePath(RouteConstants.EVENT_DETAIL, {
                            eventID: eventID,
                        });
                        history.push({
                            pathname: path,
                            state: { event: eventInfo },
                        });
                        disableButton.set(false);
                    }, 1000);
                } else {
                    disableButton.set(false);
                    setSnackBarProps({
                        ...snackBarProp,
                        openSnack: true,
                        variant: 'error',
                        message: 'This event name already exists',
                    });
                }
                loading.set(false);
            })
            .catch((error) => {
                loading.set(false);
                disableButton.set(false);

                if (error.response && error.response.status === 401) {
                    snackBarProp.variant = 'error';
                    snackBarProp.message = 'Access denied';
                } else {
                    snackBarProp.variant = 'error';
                    snackBarProp.message = 'Error while creating event';
                }
                snackBarProp.openSnack = true;
                setSnackBarProps(snackBarProp);
            });
        //debugger; // eslint-disable-line no-debugger
    };

    const handleCancel = () => {
        history.push(RouteConstants.EVENTS);
        resetState();
    };

    const handleBlur = (type, setdate) => {
        var today = new Date();
        var variable2 = today.setHours(0, 0, 0, 0);

        let msg = "Please select today's or future date";
        if (!moment(setdate).isValid()) {
            if (type == 'start')
                setStartDateError('Please enter valid start date');
            else setEndDateError('Please enter valid end date');
        } else {
            if (new Date(setdate).getTime() < new Date(variable2).getTime()) {
                if (type == 'start') setStartDateError(msg);
                else setEndDateError(msg);
            } else {
                if (type == 'start') setStartDateError('');
                else setEndDateError('');
            }
        }
    };
    const handleDisableBtn = () => {

        if (eventID > 0) {
            const editEventState = eventData;
            let prevData = {
                eventName: editEventState.eventName,
                eventStatus: editEventState.status,
                readonlyOrHide: editEventState.readonlyOrHide,
                startDate: editEventState.startDate,
                endDate: editEventState.endDate,
                venue: editEventState.venue,
                notes: editEventState.notes,
                highLevelEventInfo: editEventState.highLevelEventInfo
            }
            const fetStartDate = Helper.LocalEasternTime(
                `${Helper.FormatYearDate(eventStartDate)}T00:00:00`
            );

            const fetEndDate = Helper.LocalEasternTime(
                `${Helper.FormatYearDate(eventEndDate)}T00:00:00`
            );

            let currentData = {
                eventName: state.get().eventName,
                eventStatus: state.get().eventStatus,
                readonlyOrHide: state.get().eventView,
                startDate: Helper.ConvertToEasternTime(fetStartDate),
                endDate: Helper.ConvertToEasternTime(fetEndDate),
                venue: state.get().eventLocation,
                notes: state.get().eventNotes,
                highLevelEventInfo: state.get().highLevelEventInfo,
            }

            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true)
            } else {
                setDisableBtn(false)
            }
        }

    }

    const setEditorValue = (value) => {
        state.eventNotes.set(value);
        handleDisableBtn();
    }
    const setHighLevelInfoValue = (value) => {
        state.eventHighLevelInfo.set(value);
        handleDisableBtn();
    }

    return (
        <Box
            sx={{
                width: '100%',
            }}>
            {loader ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box className="contentBox">
                    <Box
                        component="form"
                        sx={{
                            // p: 2,
                            width: '100%',
                            '& .MuiGrid-item': { p: 2 },
                            '& .MuiTextField-root': { width: '100%' },
                            '& .MuiFormControl-root': { width: '100%' },
                            '& textarea': { width: '100%' },
                        }}
                        autoComplete="off"
                        onSubmit={handleClick}>
                        <Title
                            title={'Event'}
                            sx={{ p: 1 }}
                        />
                        <Box sx={{ width: '100%', display: 'flex', mb: 2 }}>
                            <Grid
                                container
                                spacing={2}
                                style={{
                                    marginLeft: 0,
                                    marginTop: 0,
                                    width: '100%',
                                }}>
                                <Grid
                                    item
                                    lg={eventID > 0 ? 6 : 12}
                                    md={eventID > 0 ? 6 : 12}
                                    xs={eventID > 0 ? 7 : 12}>
                                    <TextField
                                        size="small"
                                        fullWidth
                                        required
                                        id="outlined-required"
                                        label="Event Name"
                                        value={state.eventName.get()}
                                        onChange={(event) => {
                                            let str = event.target.value;
                                            str = str.replace(/^\s+/g, '');

                                            if (
                                                str.match(/^[ a-zA-Z0-9\-_&]*$/)
                                            ) {
                                                setEventNameErr('');
                                            } else {
                                                setEventNameErr(
                                                    'Event name should not have special characters'
                                                );
                                            }
                                            state.eventName.set(str);
                                            handleDisableBtn();
                                        }}
                                        inputProps={{
                                            maxLength: 50,
                                        }}
                                        error={
                                            eventNameErr.length > 0
                                                ? true
                                                : false
                                        }
                                        helperText={
                                            eventNameErr.length > 0
                                                ? eventNameErr
                                                : ''
                                        }
                                    />
                                </Grid>
                                {eventID > 0 && (
                                    <>
                                        <Grid item lg={3} md={3} xs={5}>
                                            <FormControl size="small">
                                                <InputLabel id="demo-simple-select-label">
                                                    Status
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={state.eventStatus.get()}
                                                    label="Status"
                                                    onChange={(event) => {
                                                        state.eventStatus.set(
                                                            event.target.value
                                                        );
                                                        handleDisableBtn();
                                                    }
                                                    }>
                                                    {selectStatus.map(
                                                        (item) => {
                                                            return (
                                                                <MenuItem
                                                                    value={
                                                                        item.id
                                                                    }
                                                                    key={`status_${item.id}`}>
                                                                    {item.value}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item lg={3} md={3} xs={5}>
                                            <FormControl size="small">
                                                <InputLabel id="demo-simple-select-label">
                                                    Event Mode
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={state.eventView.get()}
                                                    label="Event Mode"
                                                    onChange={(event) => {
                                                        state.eventView.set(
                                                            event.target.value
                                                        );
                                                        handleDisableBtn();
                                                    }
                                                    }>
                                                    {eventView.map((item) => {
                                                        return (
                                                            <MenuItem
                                                                value={
                                                                    item.value
                                                                }
                                                                key={`status_${item.value}`}>
                                                                {item.name}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </>
                                )}
                                <Grid item lg={4} md={4} xs={12}>
                                    <MUIDatePicker
                                        label="Start Date"
                                        value={eventStartDate}
                                        error={startDateError}
                                        setValue={setEventStartDate}
                                        disablePast={eventID > 0 ? false : true}
                                    />
                                </Grid>
                                <Grid item lg={4} md={4} xs={12}>
                                    <MUIDatePicker
                                        label="End Date"
                                        value={eventEndDate}
                                        error={endDateError}
                                        setValue={setEventEndDate}
                                        disablePast={eventID > 0 ? false : true}
                                    />
                                </Grid>
                                <Grid item lg={4} md={4} xs={12}>
                                    <TextField
                                        size="small"
                                        required
                                        id="outlined-required"
                                        label="Location"
                                        value={state.eventLocation.get()}
                                        onChange={(event) => {
                                            let str = event.target.value;
                                            // str = str.replace(/^\s+/g, '');

                                            // if (
                                            //     str.match(/^[ a-zA-Z0-9\-_&]*$/)
                                            // ) {
                                            //     setEventLocErr('');
                                            // } else {
                                            //     setEventLocErr(
                                            //         'Location should not have special characters'
                                            //     );
                                            // }
                                            state.eventLocation.set(str);
                                            handleDisableBtn();
                                        }}
                                        inputProps={{
                                            maxLength: 100,
                                        }}
                                        error={
                                            eventLocErr.length > 0
                                                ? true
                                                : false
                                        }
                                        helperText={
                                            eventLocErr.length > 0
                                                ? eventLocErr
                                                : ''
                                        }
                                    />
                                </Grid>
                                <Grid item lg={12} md={12} xs={12}>
                                    <Box sx={{ paddingLeft: 1 }}>High Level Event Info</Box>
                                    <TinyMCEEditor
                                        value={state.eventHighLevelInfo.get()}
                                        setValue={setHighLevelInfoValue}
                                        enableImageEncode
                                    />
                                </Grid>
                                <Grid item lg={12} md={12} xs={12}>
                                    {(state.attach(Downgraded).get().eventNotes !== '' && params.eventID) &&
                                        <TinyMCEEditor
                                            value={state.eventNotes.get().toString()}
                                            setValue={setEditorValue}
                                            enableImageEncode
                                        />
                                    }
                                    {(state.attach(Downgraded).get().eventNotes === '' && params.eventID) &&
                                        <TinyMCEEditor
                                            value={state.eventNotes.get().toString()}
                                            setValue={setEditorValue}
                                            enableImageEncode
                                        />
                                    }
                                    {(!params.eventID) &&
                                        <TinyMCEEditor
                                            value={state.eventNotes.get().toString()}
                                            setValue={setEditorValue}
                                            enableImageEncode
                                        />
                                    }
                                </Grid>
                            </Grid>
                        </Box>
                        <>
                            <Divider component="div" />
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                                item>
                                <ButtonContainer
                                    handleCancel={handleCancel}
                                    buttonText={
                                        eventID > 0 ? 'Update' : 'Create'
                                    }
                                    disableButton={disableButton.get()}
                                    disableUpdateButton={eventID > 0 ? disableBtn : false}
                                />
                            </Box>
                        </>
                    </Box>
                </Box>
            )}

            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};

export default EditEventDetail;